import { ConteudoEletronicoService } from './../../../service/caixa/conteudo-eletronico.service';
import { DomSanitizer } from '@angular/platform-browser';
import { ConteudoService } from './../../../service/caixa/conteudo.service';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import { FormBuilder } from '@angular/forms';
import { MatIconRegistry } from '@angular/material/icon';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource, MatPaginator, MatSort } from '@angular/material';
import { Component, OnInit, Inject, ViewChild } from '@angular/core';

@Component({
  selector: 'app-listagem-conteudo-eletronico',
  templateUrl: './listagem-conteudo-eletronico.component.html',
  styleUrls: ['./listagem-conteudo-eletronico.component.scss']
})
export class ListagemConteudoEletronicoComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  nodeId;
  displayedColumns = ['nome', 'nodeId'];
  dataSource = new MatTableDataSource<any[]>([]);
  loading = true;
  showViewer: Boolean = false;
  horizontalPosition: MatSnackBarHorizontalPosition = 'right';
  verticalPosition: MatSnackBarVerticalPosition = 'top';
  constructor(public dialogRef: MatDialogRef<ListagemConteudoEletronicoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    iconRegistry: MatIconRegistry,
    private fb: FormBuilder,
    private _snackBar: MatSnackBar,
    sanitizer: DomSanitizer,
    private conteudoEletronicoService: ConteudoEletronicoService) { }

  ngOnInit() {
    // console.log(this.data);
    this.getConteudoEletronico(this.data.conteudoId);
  }

  getConteudoEletronico(conteudoId) {
    this.conteudoEletronicoService.listagemConteudoEle(conteudoId).subscribe(data => {
      if (data.length <= 0) {
        this.openSnackBarError('Nenhum conteúdo eletrônico cadastrado neste Conteúdo !');
      }
      this.dataSource = new MatTableDataSource(data);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.loading = false;
    }, err => {
      this.loading = false;
      console.error(err);
    });
  }

  goToLink(url: string){
    window.open(url, '_blank', 'location=yes,height=570,width=520,scrollbars=yes,status=yes'); // Open new window
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  getNodeId(row) {
    this.nodeId = row.node_id;
    //this.showViewer = true;
    this.goToLink(`view-conteudo-eletronico/${row}`);
  }

  showPreview() {
    this.showViewer = true;
  }

  onGoBack(event: any) {
    this.showViewer = false;
  }

  openSnackBarError(message: string) {
    this._snackBar.open(message,'', {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 3000,
      panelClass: ['error-snackbar']
    });
  }

}



// WEBPACK FOOTER //
// /app/src/app/components/caixa/listagem-conteudo-eletronico/listagem-conteudo-eletronico.component.ts